import FeeDiscount from './fee-discount.interface';

export default class FeeItemRule implements FeeDiscount {
  id: string;

  description: string;

  fee: number;

  feeType: string;

  applyFee: boolean;

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.description = obj.description || '';
    this.fee = obj.fee || 0;
    this.feeType = obj.feeType || '';
    this.applyFee = obj.applyFee || false;
  }

  public static of(obj: any = {}): FeeItemRule {
    return new FeeItemRule(obj || {});
  }

  public static ofList(obj: any[]): FeeItemRule[] {
    return obj.map(this.of);
  }

  getId(): string { return this.id; }

  getDescription(): string { return this.description; }

  getValue(): number { return this.fee; }

  getType(): string { return this.feeType; }

  getApply(): boolean { return this.applyFee; }
}
